module.exports = __webpack_public_path__ + "img/airplane-3.df97993d.jpg";